import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const searchByQueryWrapper: ThemedFunctor = ({ theme, $width = 'auto' }) => css`
  min-width: 12.5rem;
  width: 100%;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: ${$width};
    max-width: 100%;
  }
`;

export const searchByQueryPopoverWrapper: ThemedFunctor = ({ theme, $width = 'auto' }) => css`
  padding: ${theme.remSize[100]};
  background-color: ${theme.color.background.neutral.default.lowest};
  border: 1px solid ${theme.color.border.neutral.default.high};
  border-radius: ${theme.remSize[75]};
  transition: opacity 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[100]};
  ${searchByQueryWrapper({ theme, $width })}
`;
